module.exports = __webpack_public_path__ + "static/media/studio-slide1.129f0664.png";